import { createFileRoute } from "@tanstack/react-router";
import { IntroductionView } from "@/components/Exercises/PersonalSources/IntroductionView.tsx";

export const Route = createFileRoute(
  "/(content)/adults/exercises/(shared)/personal-sources/"
)({
  component: () => <IntroductionView audience="adults" />,
  validateSearch: (search: Record<string, unknown>) => ({
    referrer: search?.referrer as string | undefined,
    referrerGroup: search?.referrerGroup as string | undefined,
  }),
  head: () => ({
    meta: [
      {
        title: "Personal Sources of Strength - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "personalSources.title",
    navbar: {
      showTitle: true,
    },
  }),
});
